import "./css/adminpushtemplatedeletecheckmodal.css";

const AdminPushTemplateDeleteCheckModal = ({ onClose, onConfirm, count, isDeleting }) => {
  return (
    <div className="adminpushtemplatedeletecheckmodal-backdrop" onClick={onClose}>
      <div
        className="adminpushtemplatedeletecheckmodal-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="adminpushtemplatedeletecheckmodal-body">
          <div className="adminpushtemplatedeletecheckmodal-icon">🗑️</div>
          <div className="adminpushtemplatedeletecheckmodal-title">템플릿 삭제</div>
          <div className="adminpushtemplatedeletecheckmodal-desc">
            삭제할 템플릿 개수: <b>{count}개</b><br />
            삭제하면 복구할 수 없습니다. 정말로 삭제하시겠습니까?
          </div>
        </div>
        <div className="adminpushtemplatedeletecheckmodal-footer">
          <button
            className="adminpushtemplatedeletecheckmodal-btn-confirm"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? "삭제 중..." : "삭제"}
          </button>
          <button
            className="adminpushtemplatedeletecheckmodal-btn-cancel"
            onClick={onClose}
            disabled={isDeleting}
          >
            취소
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminPushTemplateDeleteCheckModal;
